var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
// Get the unique set of subCategories available for the filtered category.
var getSubCategoryOptions = function (devices, allString) {
    var options = __spreadArray([
        allString
    ], Array.from(new Set(devices === null || devices === void 0 ? void 0 : devices.map(function (device) { var _a; return (_a = device === null || device === void 0 ? void 0 : device.brand) === null || _a === void 0 ? void 0 : _a.name; }))), true).filter(function (x) { return x; });
    return options.map(function (option) {
        return { text: option, value: option.toLowerCase() };
    });
};
export default getSubCategoryOptions;
